import { RatingQuestion } from '../../../shared/models/rating-question';
import { createReducer } from '../../../shared/utilities';
import { RatingActions, RatingActionTypes } from '../actions';

export interface RatingState {
  loaded: boolean;
  loading: boolean;
  questions: RatingQuestion[];
}

const initialState: RatingState = {
  loaded: false,
  loading: false,
  questions: null,
};
const _RatingReducer = createReducer(initialState, function (state: RatingState = initialState, action: RatingActions): RatingState {
  switch (action.type) {
    case RatingActionTypes.Get_Rating_Questions:
      return { ...state, loading: true, loaded: false };
    case RatingActionTypes.Get_Ratings_Questions_Success:
      return { ...state, questions: action.payload, loading: false, loaded: true };
    case RatingActionTypes.Get_Ratings_Questions_Failure:
      return { ...state, loading: false, loaded: false };
    default:
      return state;
  }
});

/// Wrapper is necessary because ngrx AOT does not support a const representing a function
export function RatingReducer(state: RatingState, action: RatingActions): RatingState {
  return _RatingReducer(state, action);
}
export const getLoaded = (state: RatingState) => state.loaded;
export const getLoading = (state: RatingState) => state.loading;
